import { bootstrapSupabaseConfig, getSupabase, isSupabaseConfigured } from './client';
import { DEFAULT_FEATURE_VISIBILITY, normalizeFeatureVisibility } from '../../constants/featureVisibility';

/** @returns {Promise<import('../../constants/featureVisibility').FeatureVisibilityMap>} */
export async function fetchFeatureVisibility() {
  if (!isSupabaseConfigured()) {
    await bootstrapSupabaseConfig();
  }
  if (!isSupabaseConfigured()) return { ...DEFAULT_FEATURE_VISIBILITY };

  const client = getSupabase();
  if (!client) return { ...DEFAULT_FEATURE_VISIBILITY };

  const { data, error } = await client.rpc('stud_get_feature_visibility');
  if (error) {
    console.warn('[featureVisibility] fetch failed:', error.message);
    return { ...DEFAULT_FEATURE_VISIBILITY };
  }
  return normalizeFeatureVisibility(data);
}

/**
 * @param {Partial<import('../../constants/featureVisibility').FeatureVisibilityMap>} patch
 * @returns {Promise<import('../../constants/featureVisibility').FeatureVisibilityMap>}
 */
export async function setFeatureVisibility(patch) {
  if (!isSupabaseConfigured()) {
    await bootstrapSupabaseConfig();
  }
  const client = getSupabase();
  if (!client) throw new Error('Supabase not configured.');

  const { data, error } = await client.rpc('stud_admin_set_feature_visibility', { p_patch: patch });
  if (error) throw new Error(error.message || 'Could not save feature visibility.');
  return normalizeFeatureVisibility(data);
}
